import CrudService from '../core/crud-service';

export default class PartnerService extends CrudService {
  static override route = 'partner';
}
